import type { LastWatchedIdEntry } from '../../../stores/channelStats/last-watched-linear-store';

type CreateLastWatchedArgs = {
  defaultChannelId?: number;
  lastWatchedData?: Record<string, LastWatchedIdEntry>;
  pageReferenceId: string;
};

export function createLastWatched({ defaultChannelId, lastWatchedData, pageReferenceId }: CreateLastWatchedArgs) {
  const channelData = lastWatchedData?.[pageReferenceId];

  if (channelData) {
    return {
      channelId: channelData.linearId,
      hiddenChannelId: channelData.subLinearExternalId,
    };
  }

  if (defaultChannelId) {
    return {
      channelId: defaultChannelId,
      hiddenChannelId: undefined,
    };
  }
}
